import { Flex, Text } from "@chakra-ui/react";
import { useState } from "react";
import { InputVisualizarFoto } from "./InputVisualizarFoto";

export const VisualizarFotos = ({ fotoView, setFotoView, dadosModal }) => {
  const conditionalRender = {
    foto1: fotoView.foto1,
    foto2: fotoView.foto2,
    foto3: fotoView.foto3,
  };

  function openFotoView(foto) {
    setFotoView({ ...fotoView, [foto]: true });

    console.log("teste", fotoView);
  }

  function closeFotoView(foto) {
    setFotoView({ ...fotoView, [foto]: false });
  }

  return (
    <Flex flexDir="column">
      <Flex flexDir="column" mt="1rem" py="1rem" bg="#378BBF" color="white">
        <Text textAlign="center">VISUALIZAR FOTOS DA MERCADORIA</Text>
      </Flex>
      <Flex
        alignItems="center"
        justifyContent="center"
        mt="1rem"
        mb="1rem"
        gap="1rem"
      >
        <InputVisualizarFoto
          foto="Foto 1"
          openFotoView={() => openFotoView("foto1")}
          photo={dadosModal.foto_1}
        />
        <InputVisualizarFoto
          foto="Foto 2"
          openFotoView={() => openFotoView("foto2")}
          photo={dadosModal.foto_2}
        />
        <InputVisualizarFoto
          foto="Foto 3"
          openFotoView={() => openFotoView("foto3")}
          photo={dadosModal.foto_3}
        />

        {/* {(conditionalRender.foto1 && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              zIndex: 999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <iframe src="https://drive.google.com/file/d/1dFpRqRtpRBaIG3CY11Cf4SiedrQpoJt8/view" />

            <button
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                background: "red",
                color: "white",
                border: "none",
                padding: "1rem",
                fontSize: "1.5rem",
                cursor: "pointer",
              }}
              onClick={() => closeFotoView("foto1")}
            >
              Fechar
            </button>
          </div>
        )) ||
          (conditionalRender.foto2 && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0,0,0,0.5)",
                zIndex: 999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src="https://picsum.photos/500/700" alt="Foto 2" />

              <button
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  background: "red",
                  color: "white",
                  border: "none",
                  padding: "1rem",
                  fontSize: "1.5rem",
                  cursor: "pointer",
                }}
                onClick={() => closeFotoView("foto2")}
              >
                Fechar
              </button>
            </div>
          )) ||
          (conditionalRender.foto3 && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0,0,0,0.5)",
                zIndex: 999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src="https://picsum.photos/900/1200" alt="Foto 3" />

              <button
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  background: "red",
                  color: "white",
                  border: "none",
                  padding: "1rem",
                  fontSize: "1.5rem",
                  cursor: "pointer",
                }}
                onClick={() => closeFotoView("foto3")}
              >
                Fechar
              </button>
            </div>
          ))} */}
      </Flex>
    </Flex>
  );
};
